define('modules/editor/models/property_groups/page_gtm',['require','exports','module','./base'],function(require,exports,module){
  "use strict";
  var BasePropertyGroup = require("./base");
  module.exports = BasePropertyGroup.extend({
    name: "page:gtm",
    properties: ["gtmId"],
    defaults: {
      "gtmId": "",
    }
  });
});

